export class User {
    Id: number;
    Email: string; 
    Password: string;
    Active: boolean;
    Role: string;
    IsLoggedIn: boolean;
    LastActivityTime: Date;
    CreatedDate: Date;
    ApplicationId: number;    
    ApplicationName: string;
    ApplicationKey: string;
    IsAdmin: boolean;   
}